module.exports = __webpack_public_path__ + "img/girl-tapping-phone.fb9e9474.gif";